import * as React from 'react';
import { LinkPrimaryButton } from '../../uiComponents/input/Buttons';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { Icon } from '../../uiComponents/Icon';

import { Panel } from 'react-bootstrap';
import Moment from 'react-moment';
import { ImageFromBlob } from '../../uiComponents/layout/ImageFromBlob';
import { KonkurrenceMedTilmeldinger } from '../../models/KonkurrenceMedTilmeldinger';

export interface TilmeldingKonkurrenceCardProps {
    konkurrence: KonkurrenceMedTilmeldinger;
    key: number;
}

export interface TilmeldingVaelgKonkurrenceState {
    tilmeldingerCollapsed: boolean;
}

class TilmeldingKonkurrenceCard extends React.Component<TilmeldingKonkurrenceCardProps, TilmeldingVaelgKonkurrenceState> {
    constructor(props: TilmeldingKonkurrenceCardProps) {
        super(props);

        this.state = { tilmeldingerCollapsed: true };
        this.onTilmeldingerClicked = this.onTilmeldingerClicked.bind(this);
    }

    onTilmeldingerClicked() {
        let collapsed = this.state.tilmeldingerCollapsed;
        collapsed = !collapsed;
        this.setState({ tilmeldingerCollapsed: collapsed });
    }

    wrapTilmeldingerInList(opgavepakkeNavn: string, tilmeldinger: any) {
        return (
            <div className='tilmeldte-hold-list'>
                <h4>{opgavepakkeNavn}</h4>
                <ul className='list-group row padding-left'>
                    {tilmeldinger}
                </ul>
            </div>
        );
    }

    getTilmeldteHold = () => {
        let opgavepakkeNavn = '';
        let tilmeldteHold = new Array();
        let tilmeldteHoldSortedByOpgavepakke = new Array();
        this.props.konkurrence.tilmeldteHold.sort((a, b) => {
            if (a.opgavepakke.id < b.opgavepakke.id) {
                return -1;
            }
            if (a.opgavepakke.id > b.opgavepakke.id) {
                return 1;
            }
            return 0;
        }).forEach((hold, index) => {
            if ((opgavepakkeNavn.length > 0 && opgavepakkeNavn !== hold.opgavepakke.titel)) {
                tilmeldteHoldSortedByOpgavepakke.push(this.wrapTilmeldingerInList(opgavepakkeNavn, tilmeldteHold));
                tilmeldteHold = new Array();
            }

            tilmeldteHold.push((
                <li key={index} className='col-md-12'>{hold.institutionsnavn + ', ' + hold.holdnavn}</li>
            ));

            opgavepakkeNavn = hold.opgavepakke.titel;

            if (index === (this.props.konkurrence.tilmeldteHold.length - 1)) {
                tilmeldteHoldSortedByOpgavepakke.push(this.wrapTilmeldingerInList(opgavepakkeNavn, tilmeldteHold));
            }
        });

        return (
            <div>
                <ul className='list-group row padding-left'>
                    {tilmeldteHoldSortedByOpgavepakke}
                </ul>
                {this.props.konkurrence.holdPaaVenteliste.length > 0 &&
                    <div>
                        <h4>Venteliste ({this.props.konkurrence.holdPaaVenteliste.length})</h4>

                        <ul className='list-group row padding-left'>
                            {this.props.konkurrence.holdPaaVenteliste.map((h, i) =>
                                <li key={i} className='col-xs-6'>{h.institutionsnavn + ', ' + h.holdnavn}</li>
                            )}
                        </ul>
                    </div>
                }
            </div>
        );
    }

    render() {
        const derKanIkkeTilmeldesFlereHold = this.props.konkurrence.antalTilmeldteHold === this.props.konkurrence.maxAntalHold;
        const formattedDate = <Moment format='DD.MM.YY'>{String(this.props.konkurrence.startdato)}</Moment>;
        let tilmeldUrl = '/tilmelding/tilmeld-hold/' + this.props.konkurrence.id;
        let buttonText = 'Tilmeld';
        if (derKanIkkeTilmeldesFlereHold) {
            tilmeldUrl = '/tilmelding/tilmeld-hold-venteliste/' + this.props.konkurrence.id;
            buttonText = 'Skriv dig på venteliste';
        }

        const expandButton = (
            <span onClick={this.onTilmeldingerClicked}>
                Tilmeldte ({this.props.konkurrence.antalTilmeldteHold}/{this.props.konkurrence.maxAntalHold})
                <Icon className='plus' name={'plus'} />
            </span>
        );
     
        return (
            <div className='card' key={this.props.key}>
                <Panel>
                    <Row>
                        <Col md={4} className={'card-image-wrapper'}>
                            <ImageFromBlob id={this.props.konkurrence.billedId} />
                        </Col>
                        <Col md={8} className='card-info-wrapper'>
                            <div className='card-header'>
                                <h2>{formattedDate} - {this.props.konkurrence.titel}</h2>
                                <p>{this.props.konkurrence.afviklingssted}</p>
                            </div>

                            <div className='card-collapsible'>
                                <Panel header={expandButton} collapsible={true} expanded={!this.state.tilmeldingerCollapsed}>
                                    {this.getTilmeldteHold()}
                                </Panel>
                            </div>

                            <LinkPrimaryButton className='card-btn' url={tilmeldUrl} text={buttonText} />
                        </Col>
                    </Row>
                </Panel>
            </div>
        );
    }
}

export default TilmeldingKonkurrenceCard;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingKonkurrenceCard.tsx